<script setup lang="ts">
useHead({
  link: [
    { rel: 'icon', type: 'image/png', href: '/logo.png' }
  ],
  script: [
    {
      'src': 'https://umami.cech.work/script.js',
      'defer': true,
      'data-website-id': '78fde03c-b2c3-4bc7-a120-d2d72a4e4e24',
      'data-domains': 'photos.cech.work'
    }
  ],
  htmlAttrs: {
    lang: 'en'
  }
})

const route = useRoute()
const isTopicRoute = computed(() => !route.fullPath.includes('/detail/') && !route.fullPath.includes('/galleries/'))
</script>

<template>
  <UApp
    class="bg-black min-h-[100dvh] overflow-x-auto relative"
    :class="{ 'flex flex-col md:block': !isTopicRoute }"
  >
    <AppPageMenu v-if="isTopicRoute" />
    <NuxtPage />
    <ImageThumbnailList
      :class="!isTopicRoute ? 'opacity-100 z-[9999]' : 'opacity-0 z-[-1]'"
    />
  </UApp>
</template>

<style>
@import "tailwindcss";
@import "@nuxt/ui";

@theme {
  --font-family-sans: 'Inter', sans-serif;
}
</style>
